import Cell from "@/components/quote/Cell";
import FobBuilder from "@/components/quote/FobBuilder";
import { Plus, Trash2, PackagePlus, Copy } from "lucide-react";

export default function SuministroTab({ doors, characteristics, showPrices, changedDoors = {},
  onDoor, onDoorPatch, onAddDoor, onRemoveDoor, onDuplicateDoor }) {
  return (
    <div className="space-y-4">
      <div className="bg-white border border-slate-200 rounded-lg overflow-hidden">
        <div className="flex items-center justify-between px-4 py-3 border-b border-slate-200">
          <div>
            <h3 className="font-display font-bold text-slate-900 text-sm uppercase tracking-wide">Suministro de puertas</h3>
            <p className="text-xs text-slate-500 mt-0.5">Agrega cada puerta y marca sus características.</p>
          </div>
          <button data-testid="add-door-btn" onClick={onAddDoor}
            className="flex items-center gap-1.5 text-sm bg-emerald-600 hover:bg-emerald-700 text-white font-medium px-3 py-2 rounded-md transition-colors">
            <Plus className="h-4 w-4" /> Agregar puerta
          </button>
        </div>

        {doors.length === 0 ? (
          <div className="p-12 text-center" data-testid="doors-empty">
            <PackagePlus className="h-10 w-10 text-slate-300 mx-auto mb-3" />
            <p className="text-slate-500 text-sm">Aún no hay puertas. Presiona “Agregar puerta” para empezar.</p>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="text-xs uppercase tracking-wider text-slate-500 border-b border-slate-200 bg-slate-50">
                  <th className="px-2 py-2 text-left w-12">#</th>
                  <th className="px-2 py-2 text-left w-28">Código</th>
                  <th className="px-2 py-2 text-right w-20">A (m)</th>
                  <th className="px-2 py-2 text-right w-20">H (m)</th>
                  <th className="px-2 py-2 text-right w-20">Cant.</th>
                  <th className="px-2 py-2 text-left">Características</th>
                  <th className="px-2 py-2 w-16"></th>
                </tr>
              </thead>
              <tbody>
                {doors.map((d, i) => (
                  <tr key={d.id} className={`border-b border-slate-100 ${changedDoors[d.id] ? "bg-amber-50 hover:bg-amber-100/60 border-l-4 border-l-amber-400" : "hover:bg-slate-50 bg-white"}`} data-testid={`door-row-${d.id}`}>
                    <td className="px-2 py-1 text-slate-400 font-mono text-xs">{i + 1}</td>
                    <td className="px-1 py-1"><Cell type="text" testid={`door-code-${d.id}`} value={d.code} onChange={(v) => onDoor(d.id, "code", v)} /></td>
                    <td className="px-1 py-1"><Cell step={0.05} testid={`door-width-${d.id}`} value={d.width} onChange={(v) => onDoor(d.id, "width", v)} /></td>
                    <td className="px-1 py-1"><Cell step={0.05} testid={`door-height-${d.id}`} value={d.height} onChange={(v) => onDoor(d.id, "height", v)} /></td>
                    <td className="px-1 py-1"><Cell testid={`door-qty-${d.id}`} value={d.qty} onChange={(v) => onDoor(d.id, "qty", v)} /></td>
                    <td className="px-2 py-1">
                      <FobBuilder door={d} characteristics={characteristics} onPatch={onDoorPatch} showPrices={showPrices} />
                      {changedDoors[d.id] && (
                        <p className="text-[11px] text-amber-700 font-medium mt-0.5" data-testid={`door-price-changed-${d.id}`}>
                          Precio cambiado en catálogo: {changedDoors[d.id].join(", ")}
                        </p>
                      )}
                    </td>
                    <td className="px-1 py-1 text-center">
                      <div className="flex items-center justify-center gap-1.5">
                        <button data-testid={`door-dup-${d.id}`} onClick={() => onDuplicateDoor(d.id)} title="Duplicar puerta"
                          className="text-slate-300 hover:text-emerald-600">
                          <Copy className="h-3.5 w-3.5" />
                        </button>
                        <button data-testid={`door-del-${d.id}`} onClick={() => onRemoveDoor(d.id)} title="Eliminar"
                          className="text-slate-300 hover:text-red-500">
                          <Trash2 className="h-3.5 w-3.5" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
